import { element } from '../../../core/elements';
import { jsx as _jsx } from "react/jsx-runtime";
const tickStroke = "var(--ds-border-bold, lightgrey)";
const TICK_LENGTH = 8;
const STROKE_WIDTH = 1;
export const Tick = element(props => {
  const {
    from,
    to,
    hide
  } = props;
  const isHorizontal = (from === null || from === void 0 ? void 0 : from.y) === (to === null || to === void 0 ? void 0 : to.y);
  if (hide) return null;
  const border = isHorizontal ? {
    borderBottom: `${STROKE_WIDTH}px solid ${tickStroke}`
  } : {
    borderLeft: `${STROKE_WIDTH}px solid ${tickStroke}`
  };
  return /*#__PURE__*/_jsx("div", {
    style: {
      ...border,
      width: isHorizontal ? TICK_LENGTH : 0,
      height: !isHorizontal ? TICK_LENGTH : 0,
      position: 'absolute',
      top: `calc(${to === null || to === void 0 ? void 0 : to.y}px)`,
      left: `calc(${from === null || from === void 0 ? void 0 : from.x}px)`,
      transform: isHorizontal ? `translateX(-${TICK_LENGTH}px)` : ``
    }
  });
});